import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatPrismicImage } from '~/helpers/image-helper';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  components: {
    GlobalRichText: GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      return {
        image: "".concat(formatPrismicImage(this.payload.primary.img.url, ['w_375']), " 375w, ").concat(formatPrismicImage(this.payload.primary.img.url, ['w_375', 'dpr_2']), " 750w, ").concat(formatPrismicImage(this.payload.primary.img.url, ['w_1440']), " 1440w, ").concat(formatPrismicImage(this.payload.primary.img.url, ['w_1440', 'dpr_2']), " 2880w"),
        background: "".concat(formatPrismicImage(this.payload.primary.background.url, ['w_375']), " 375w")
      };
    },
    tracking: function tracking() {
      return {
        data: {
          event_category: this.payload.primary.event_category || '',
          event_action: this.payload.primary.event_action || '',
          event_label: this.payload.primary.event_label || ''
        }
      };
    }
  }
};